function initializeFacebookPixel(): void {
  if (window.fbq) return;

  function fbq(): void {
    const callMethod = getCallMethod(fbq);
    if (callMethod) {
      // eslint-disable-next-line prefer-rest-params
      callMethod.apply(fbq, Array.from(arguments));
      return;
    }

    // eslint-disable-next-line prefer-rest-params
    fbq.queue.push(arguments);
  }

  function getCallMethod(pixelStub: FacebookPixelFunction): FacebookPixelFunction['callMethod'] {
    return pixelStub.callMethod;
  }

  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = new Array<IArguments>();

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode!.insertBefore(script, firstScript);
}

initializeFacebookPixel();

export {};
